export const FORM_FIELDS = {
  'first_name': gettext('Имя'),
  'last_name': gettext('Фамилия'),
  'birthday': gettext('Дата рождения'),
  'sex': gettext('Пол'),
  'phone_number': gettext('Номер телефона'),
  'living_place': gettext('Место жительства'),
  'about': gettext('Расскажите о себе'),
  'lang': gettext('Предпочитаемый язык'),
  'payment_service': gettext('Платежный сервис'),
  'slug': gettext('Адрес страницы'),
}

export const FORM_FILED_SEX = {
  'male': gettext('Мужской'),
  'female': gettext('Женский'),
}